export function resetSelectedBoxValues(elementId: string) {
    let elements = document.getElementById(elementId).selectedOptions;

    for (var i = 0; i < elements.length; i++) {
        elements[i].selected = false;
    }
}
